import { Controller } from '@hotwired/stimulus'

export default class EventTabsController extends Controller {
  static targets = ['tab', 'tabContent']

  connect () {
    if (this.hasTabTarget && this.tabTargets.length > 0) {
      const firstTab = this.tabTargets[0]
      if (firstTab) {
        this.activateTab(firstTab)
      }
    }

    this.boundHandleStreamRender = this.handleStreamRender.bind(this)

    document.addEventListener('turbo:stream-render', this.boundHandleStreamRender)
  }

  disconnect () {
    document.removeEventListener('turbo:stream-render', this.boundHandleStreamRender)
  }

  handleStreamRender (event) {
    const activeTab = this.tabTargets.find(tab => tab.classList.contains('active'))
    if (activeTab) {
      setTimeout(() => {
        this.activateTab(activeTab)
      }, 0)
    } else {
      if (this.hasTabTarget && this.tabTargets.length > 0) {
        setTimeout(() => {
          this.activateTab(this.tabTargets[0])
        }, 0)
      }
    }
  }

  switchTab (event) {
    event.preventDefault()
    event.stopPropagation()

    const tab = event.currentTarget
    if (tab) {
      this.activateTab(tab)
    }
  }

  activateTab (tab) {
    if (!tab || !tab.dataset || !tab.dataset.tabType) {
      return
    }

    const tabType = tab.dataset.tabType

    if (this.hasTabContentTarget) {
      this.tabContentTargets.forEach(content => {
        if (content) {
          content.classList.add('hidden')
        }
      })
    }

    if (this.hasTabTarget) {
      this.tabTargets.forEach(t => {
        if (t && t.classList) {
          t.classList.remove('active')
        }
      })
    }

    const contentId = `${tabType}-sessions-content`
    const content = document.getElementById(contentId)
    if (content) {
      content.classList.remove('hidden')
    }

    if (tab.classList) {
      tab.classList.add('active')
    }
  }
}
